import * as React from 'react';
import { openCodePaneMediaPreview } from '@/lib/notebook/codePaneSync';

interface AgentImagePreviewRequest {
  src: string;
  alt: string;
  caption?: string | null;
  mediaType?: string | null;
  downloadName?: string | null;
}

interface AgentImagePreviewContextValue {
  openImage: (request: AgentImagePreviewRequest) => boolean;
}

export interface AgentImagePreviewProviderProps {
  children: React.ReactNode;
}

const AgentImagePreviewContext = React.createContext<AgentImagePreviewContextValue | null>(null);

export function AgentImagePreviewProvider({ children }: AgentImagePreviewProviderProps): React.ReactElement {
  const openImage = React.useCallback((request: AgentImagePreviewRequest): boolean => {
    return openCodePaneMediaPreview({
      name: request.downloadName ?? request.caption ?? request.alt,
      src: request.src,
      mime: request.mediaType ?? 'image',
      source: 'agent-image-preview',
    });
  }, []);

  const contextValue = React.useMemo(() => ({ openImage }), [openImage]);

  return <AgentImagePreviewContext.Provider value={contextValue}>{children}</AgentImagePreviewContext.Provider>;
}

export function useAgentImagePreview(): AgentImagePreviewContextValue | null {
  return React.useContext(AgentImagePreviewContext);
}
